export default {
	// BASEURL: "https://api.qingzhou.link/wxapi",   //魏县
	// BASEURL: "http://frp2.qingzhou.link:22278",
	BASEURL: "https://api.qingzhou.link/api3",
	hasPermission(perms, permsList) {
		let r = false
		for (let i = 0, len = permsList.length; i < len; i++) {
			if (permsList[i] === perms) {
				r = true
				break
			}
		}
		return r
	}

}
